import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Programs() {
  const programs = [{
    title: '2026 Camp Season',
    description: 'Two weeks of African-centered education, outdoor adventures, creative expression, and community building at Beulah Land Farms.',
    dates: 'June 20 – July 5, 2026',
    image: 'https://cdn.magicpatterns.com/uploads/288tHxhpqXNwz7twcGjVJJ/hero-grass.jpg'
  }, {
    title: 'Sister Circle',
    description: 'A sacred space for young women to connect, share, and grow through guided discussions, mentorship, and sisterhood.',
    image: 'https://cdn.magicpatterns.com/uploads/1cVzY9WxpvuQmDLiJA6pso/sister-circle.jpg'
  }, {
    title: 'Tie Dye Day',
    description: 'Creative expression meets community fun — campers design their own wearable art in this beloved camp tradition.',
    image: 'https://cdn.magicpatterns.com/uploads/gNtCRcz44oYku2JETSjmSY/tie-dye-day.jpg'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="programs" className="bg-forest py-20 md:py-28" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-92">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-93">
            <h2 className="font-heading text-cream text-4xl md:text-5xl font-bold mb-4" data-id="element-94">
              Our Programs
            </h2>
            <div className="w-20 h-1 bg-gold mb-6 rounded-full" data-id="element-95" />
            <p className="text-cream/90 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-96">
              Experiences that transform, educate, and inspire
            </p>
          </motion.div>
        </div>

        {/* Cards Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-97">
          {programs.map((program, index) => <motion.div key={index} variants={cardVariants} className="group relative rounded-2xl overflow-hidden backdrop-blur-md bg-white/5 border border-white/10 flex flex-col h-full hover:bg-white/10 transition-colors duration-300" data-id="element-98">
              {/* Image Header */}
              <div className="relative h-48 sm:h-56 overflow-hidden" data-id="element-99">
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110" style={{
              backgroundImage: `url(${program.image})`
            }} data-id="element-100" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/40 to-transparent" data-id="element-101" />
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow relative z-10" data-id="element-102">
                <h3 className="font-heading text-cream text-2xl font-bold mb-3" data-id="element-103">
                  {program.title}
                </h3>
                {program.dates && <p className="text-gold text-sm font-bold mb-3 uppercase tracking-wider" data-id="element-104">
                    {program.dates}
                  </p>}
                <p className="text-cream/80 leading-relaxed mb-6 flex-grow" data-id="element-105">
                  {program.description}
                </p>
                <div className="mt-auto" data-id="element-106">
                  <a href="#contact" className="inline-flex items-center text-gold font-medium hover:text-white transition-colors" data-id="element-107">
                    Learn more{' '}
                    <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-108">
                      →
                    </span>
                  </a>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}